import styled, { css, keyframes } from 'styled-components';
import { SkeletonProps } from './types';

const opacityAnimation = keyframes`
  0% {opacity: 1}
  50% {opacity: 0.65}
  100% {opacity: 1}
`;

export const Skeleton = styled.div<SkeletonProps>`
  ${({ theme: { border }, width, height, margin, radius = 'xlarge' }) => css`
    animation: ${opacityAnimation} 1.2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    background: linear-gradient(90deg, #dadee7 0%, #f3f4f6 100%);
    border-radius: ${border.radius[radius]};

    ${width &&
    css`
      width: ${width};
    `}

    ${height &&
    css`
      height: ${height};
    `}

    ${margin &&
    css`
      margin: ${margin};
    `}
  `}
`;

export const ParagraphSkeletonContainer = styled.div`
  display: flex;
  gap: 0.25rem;
  flex-direction: column;
`;

export const TextFieldSkeletonContainer = styled.div`
  display: grid;
  grid-gap: 0.375rem;
`;
